
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 2.586l-9 9v5.415h5.414l8.995-8.994L13 2.586zM6 15v-2.586l7-6.999 2.582 2.59L8.586 15H6z"}}),_c('path',{attrs:{"d":"M4 21h16v-2H4v2z"}})])
          )
        }
      }
    